import React from 'react';
import Hero from '../components/sections/Hero';
import Features from '../components/sections/Features';
import LandTypes from '../components/sections/LandTypes';
// HowItWorks and FeaturedProperties sections removed as requested
// Testimonials section removed as requested
import CallToAction from '../components/sections/CallToAction';
import ContactForm from '../components/sections/ContactForm';

const Home = () => {
  return (
    <>
      <Hero />
      <Features />
      <LandTypes />
      {/* HowItWorks section removed - redundant with HowItWorks page */}
      {/* FeaturedProperties section removed as requested */}
      {/* Testimonials section removed as requested */}
      <CallToAction />
      <ContactForm />
    </>
  );
};

export default Home;
